'use es6';

import { DispatcherInstance } from 'general-store';
import dispatcher from 'dispatcher/dispatcher';
DispatcherInstance.set(dispatcher);